import React from 'react'
import { css } from '@emotion/core'
import heritageWorldMap from './assets/heritageWorldMap.svg'

/*
 * Imported rather than served from public/, so the map is owned by this feature and webpack
 * fingerprints it like any other asset. The pre-React shell in views/index.ejs cannot reference a
 * hashed filename, so it no longer paints the map at all - it shows the green and the veil, and
 * this backdrop supplies the map as soon as React mounts.
 */
export const HERITAGE_WORLD_MAP_URL = heritageWorldMap

// Both screens that use this backdrop switch composition at 700px. Kept local so this module
// never has to import back into PmhBrowse.
const RESPONSIVE_BREAKPOINT = 700

/**
 * The surface the backdrop layers sit on. Spread into whichever element owns the screen - it
 * establishes the containing block the two absolute layers below need, and carries the green the
 * map is drawn over.
 */
export const heritageBackdropSurfaceCss = css`
  position: relative;
  overflow: hidden;
  color: #ffffff;
  background-color: #235c35;
`

const mapCss = css`
  position: absolute;
  inset: 0;
  z-index: 0;
  background-image: url(${HERITAGE_WORLD_MAP_URL});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  filter: brightness(0);
  opacity: 0.55;
  pointer-events: none;

  @media (min-width: ${RESPONSIVE_BREAKPOINT}px) {
    opacity: 0.5;
  }
`

const veilCss = css`
  position: absolute;
  inset: 0;
  z-index: 0;
  background: linear-gradient(180deg, #0e28198f 0%, #1231207a 100%);
  pointer-events: none;

  @media (min-width: ${RESPONSIVE_BREAKPOINT}px) {
    background: transparent;
  }
`

/**
 * The shared Picture My Heritage backdrop: the world map over green, under a veil that only
 * darkens below the 700px breakpoint. Used by the catalog and by the Group Portrait overview, which
 * is why it lives here rather than in either one.
 *
 * Content drawn over this must establish its own stacking position - both layers are absolutely
 * positioned at `z-index: 0`, so static siblings would otherwise paint underneath them.
 */
export default function HeritageBackdrop() {
  return (
    <>
      <div css={mapCss} aria-hidden="true" data-pmh2-heritage-map />
      <div css={veilCss} aria-hidden="true" data-pmh2-heritage-veil />
    </>
  )
}
